<template>
  <section>
      <h2>Page not found</h2>
      <p>
        This page could not be found - maybe check out all our
        <router-link to="/catalog">items in catalog</router-link>.
      </p>
  </section>
</template>